import { useGetUmbracoTafDeliveryApiV1BookingObjectsListDockumentKeyChildrenSuspense } from '@shared/integrations/umbraco-taf-delivery-api/features/object-booking/object-booking.ts';
import BookingObjectListItem from '@my-pages/features/object-booking/components/BookingObjectListItem.tsx';

interface IBookingObjectsListProps {
    contentId: string;
}
const BookingObjectsListChildren = ({ contentId }: IBookingObjectsListProps) => {
    const { data } = useGetUmbracoTafDeliveryApiV1BookingObjectsListDockumentKeyChildrenSuspense(contentId);

    return (
        <div className='row'>
            {data?.map((x) => (
                <div
                    key={x.id}
                    className='col-md-4 pb-4'
                >
                    <BookingObjectListItem item={x} />
                </div>
            ))}
        </div>
    );
};

export default BookingObjectsListChildren;
